import { create } from 'zustand';
import type { User } from '../types/user';
import { getCurrentUser, logout as apiLogout } from '../api/auth';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  error: string | null;
  tenant: string | null;

  setUser: (user: User | null) => void;
  setTenant: (tenant: string) => void;
  checkAuth: (tenant: string) => Promise<void>;
  logout: () => Promise<void>;
  clearError: () => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isLoading: true,
  isAuthenticated: false,
  error: null,
  tenant: null,

  setUser: (user) => {
    set({ user, isAuthenticated: !!user, isLoading: false });
  },

  setTenant: (tenant) => {
    set({ tenant });
  },

  checkAuth: async (tenant) => {
    set({ isLoading: true, error: null, tenant });

    try {
      const response = await getCurrentUser(tenant);
      set({
        user: response.user,
        isAuthenticated: true,
        isLoading: false,
      });
    } catch (error) {
      set({
        user: null,
        isAuthenticated: false,
        isLoading: false,
      });
    }
  },

  logout: async () => {
    const { tenant } = get();
    if (!tenant) return;

    try {
      await apiLogout(tenant);
    } catch (error) {
      console.error('Logout error:', error);
    }

    // Clear token from localStorage
    localStorage.removeItem('auth_token');

    set({
      user: null,
      isAuthenticated: false,
    });
  },

  clearError: () => {
    set({ error: null });
  },
}));
